import { prefersReducedMotion } from './prefersReducedMotion.js';

/**
 * Scroll-scrubbed parallax: translates down AND scales up as the element
 * passes the top of the viewport. The 1.02 starting scale gives a buffer so
 * translating never exposes the image edges — mirrors the Next prototype's
 * `imageY` + `imageScale` transforms on the hero.
 */
export default () => ({
  init() {
    if (prefersReducedMotion()) return;
    window.gsap.fromTo(
      this.$el,
      { scale: 1, yPercent: 0 },
      {
        scale: 1.12,
        yPercent: 8,
        ease: 'none',
        scrollTrigger: {
          trigger: this.$el,
          start: 'top top',
          end: 'bottom top',
          scrub: true,
        },
      }
    );
  },
});
